
export const useNewLayout = ['/', '/good-coverage/']
